import ReportType from 'common/constants/reportType'
import {
  ChannelServiceType as ReviewChannelServiceType,
  Review,
  ReviewProduct,
  ReviewServiceType,
} from 'common/types/entities/api/review'

export interface QnaReportRegister {
  contentId: string
  serviceType: ChannelServiceType
  contentType: ContentType
  reportId: string
  reportPolicy: ReportType
  reportPolicyRemark: string
  reportUserType: ReportUserType
  reportDateByLong: number
}

export interface ReviewReportRegister {
  contentId: string
  serviceType: ChannelServiceType
  contentType: ContentType
  reportId: string
  reportPolicy: ReportType
  reportPolicyRemark: string
  reportUserType: ReportUserType
  reportDate: Date
}

export enum ChannelServiceType {
  SHOP_NAVER = 'SHOP_NAVER',
  SHOPPING_WINDOW = 'SHOPPING_WINDOW',
  CHECK_OUT = 'CHECK_OUT',
}

// https://wiki.navercorp.com/pages/viewpage.action?pageId=395953233
export enum ContentType {
  PHOTO_REVIEW = 'PHOTO_REVIEW', // 일반_포토리뷰
  VIDEO_REVIEW = 'VIDEO_REVIEW', // 일반_동영상리뷰
  TEXT_REVIEW = 'TEXT_REVIEW', // 일반_텍스트리뷰
  TEXT_REVIEW_COMMENT = 'TEXT_REVIEW_COMMENT', // 일반_텍스트리뷰_덧글
  MONTH_PHOTO_REVIEW = 'MONTH_PHOTO_REVIEW', // 한달_포토리뷰
  MONTH_VIDEO_REVIEW = 'MONTH_VIDEO_REVIEW', // 한달_동영상리뷰
  MONTH_TEXT_REVIEW = 'MONTH_TEXT_REVIEW', // 한달_텍스트리뷰
  MONTH_TEXT_REVIEW_COMMENT = 'MONTH_TEXT_REVIEW_COMMENT', // 한달_텍스트리뷰_덧글
  WINDOW_QUESTION = 'WINDOW_QUESTION', // 윈도상품질문
  WINDOW_ANSWER = 'WINDOW_ANSWER', // 윈도상품답변
  WINDOW_NEWS = 'WINDOW_NEWS',
}

export const getReviewContentType = (reviewContentClassType: string, reviewType: string, commentId?: string) => {
  if (commentId) {
    if (reviewType === 'NORMAL') {
      return ContentType.TEXT_REVIEW_COMMENT
    }
    if (reviewType === 'AFTER_USE') {
      return ContentType.MONTH_TEXT_REVIEW_COMMENT
    }
  } else {
    switch (reviewContentClassType) {
      case 'TEXT':
        if (reviewType === 'NORMAL') {
          return ContentType.TEXT_REVIEW
        }
        if (reviewType === 'AFTER_USE') {
          return ContentType.MONTH_TEXT_REVIEW
        }
      case 'PHOTO':
        if (reviewType === 'NORMAL') {
          return ContentType.PHOTO_REVIEW
        }
        if (reviewType === 'AFTER_USE') {
          return ContentType.MONTH_PHOTO_REVIEW
        }
      case 'VIDEO':
        if (reviewType === 'NORMAL') {
          return ContentType.VIDEO_REVIEW
        }
        if (reviewType === 'AFTER_USE') {
          return ContentType.MONTH_VIDEO_REVIEW
        }
    }
  }
}

export enum ReportUserType {
  SHOPPER = 'SHOPPER',
  CHECKOUT_SELLER = 'CHECKOUT_SELLER',
  SHOPN_SELLER = 'SHOPN_SELLER',
  WINDOW_SELLER = 'WINDOW_SELLER',
}

export enum Message {
  EMPTY_REPORT = '신고내용을 입력해주세요.',
  SHORT_CONTENT = '최소 10자 이상으로 작성해주세요.',
  ALREADY_DONE = '이미 신고한 글입니다.',
  WELL_DONE = '신고해 주셔서 감사합니다.\n신고해주신 내용 꼼꼼히 검토하여 처리하겠습니다.',
  FAILURE = '신고 등록을 실패하였습니다.',
}

export const getReviewServiceType = (review: Review | ReviewProduct) => {
  const { reviewServiceType, channelServiceType } = review
  if (reviewServiceType === ReviewServiceType.CHECKOUT) {
    return ChannelServiceType.CHECK_OUT
  }
  switch (channelServiceType) {
    case ReviewChannelServiceType.STOREFARM:
      return ChannelServiceType.SHOP_NAVER
    case ReviewChannelServiceType.WINDOW:
      return ChannelServiceType.SHOPPING_WINDOW
  }
}
